goog.provide("shadow.js.shim.module$src$svg$type$ad_format$meta_carousel_svg$default");
shadow.js.shim.module$src$svg$type$ad_format$meta_carousel_svg$default = shadow.js.shim.module$src$svg$type$ad_format$meta_carousel_svg.default;
